import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4acd0af0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex table-responsive" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "fit" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "fit" }, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  class: "empty-state py-8 px-12 text-center",
  colspan: "222222"
}
const _hoisted_6 = { class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center" }
const _hoisted_7 = { class: "h5 title text-primary mb-48" }
const _hoisted_8 = { class: "fit" }
const _hoisted_9 = { class: "fit" }
const _hoisted_10 = { class: "fit" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-view-light mb-4"
}, null, -1))
const _hoisted_12 = { class: "fw-normal" }
const _hoisted_13 = { class: "fit" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-close mb-4"
}, null, -1))
const _hoisted_15 = { class: "fw-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_table_header = _resolveComponent("v-table-header")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_protocol_name = _resolveComponent("v-protocol-name")!
  const _component_v_table_body = _resolveComponent("v-table-body")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_the_professional_treatment_finish_confirm_modal = _resolveComponent("the-professional-treatment-finish-confirm-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_table, { class: "table-bordered" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_table_header, null, {
            default: _withCtx(() => [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('Inicio')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('Fin')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('Descripción')), 1),
                _hoisted_2,
                _hoisted_3
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_table_body, null, {
            default: _withCtx(() => [
              (!_ctx.treatments.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                    _createElementVNode("td", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('No hay tratamientos')), 1),
                        (!_ctx.currentTreatment && _ctx.can('professional.expedient.anamnesis.start'))
                          ? (_openBlock(), _createBlock(_component_v_button, {
                              key: 0,
                              "aria-label": _ctx.$t('Iniciar tratamiento'),
                              variant: "secondary",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('emit-show-start-anamnesis-modal')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('Iniciar tratamiento')), 1)
                              ]),
                              _: 1
                            }, 8, ["aria-label"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.treatments, (treatment, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$str.formatDate(treatment.createdAt)), 1),
                      _createElementVNode("td", _hoisted_9, [
                        _createElementVNode("span", {
                          class: _normalizeClass({ 'text-success': treatment.status !== 'finalized'})
                        }, [
                          (treatment.status !== 'finalized')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t('En curso')), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(!!treatment.endDate ? _ctx.$str.formatDate(treatment.endDate) : '-'), 1)
                              ], 64))
                        ], 2)
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_v_protocol_name, {
                          color: treatment?.treatmentProtocolPhases[0]?.protocolPhase?.protocol?.type,
                          text: treatment?.treatmentProtocolPhases[0]?.protocolPhase?.protocol?.name,
                          class: "fw-normal"
                        }, null, 8, ["color", "text"])
                      ]),
                      _createElementVNode("td", _hoisted_10, [
                        (_ctx.can('professional.expedient.treatment.show'))
                          ? (_openBlock(), _createBlock(_component_v_button, {
                              key: 0,
                              "aria-label": _ctx.$t('Seleccionar tratamiento'),
                              class: "text-primary d-flex flex-column p-0 m-auto",
                              variant: "icon",
                              onClick: ($event: any) => (_ctx.setCurrentTreatment(treatment.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_11,
                                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('Ver')), 1)
                              ]),
                              _: 2
                            }, 1032, ["aria-label", "onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_13, [
                        (treatment && _ctx.can('professional.expedient.treatment.finish') &&
                treatment.status !== 'finalized')
                          ? (_openBlock(), _createBlock(_component_v_button, {
                              key: 0,
                              "aria-label": _ctx.$t('Finalizar tratamiento'),
                              class: "text-primary d-flex flex-column p-0 m-auto",
                              variant: "icon",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalToShow = 'the-professional-treatment-finish-confirm-modal'))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_14,
                                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('Finalizar')), 1)
                              ]),
                              _: 1
                            }, 8, ["aria-label"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.modalToShow === 'the-professional-treatment-finish-confirm-modal')
      ? (_openBlock(), _createBlock(_component_the_professional_treatment_finish_confirm_modal, {
          key: 0,
          onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalToShow = null))
        }))
      : _createCommentVNode("", true)
  ], 64))
}